const SOURCE_VECTOR = 'vector';

export default class ThemeWrapper {
    static TYPE = {
        URL: 'URL',
        OBJECT: 'OBJECT',
        RESOLVED_SCHEMA: 'RESOLVED_SCHEMA'
    };

    constructor(type, options) {
        this.type = type;
        this.options = options;
    }

    unwrap = () => {
        return this.options;
    }

    getType = () => {
        return this.type;
    }

    getSource = () => {
        return this.getType() === (ThemeWrapper.TYPE.URL || ThemeWrapper.TYPE.OBJECT) ?
            SOURCE_VECTOR :
            this.options.source;
    }
}



// WEBPACK FOOTER //
// ./map/configurer/styleOptionInitialization/themeWrapper.js